module.exports = __webpack_public_path__ + "img/exam.63be8836.png";